<template>
  <Widgets
    :initial-definition="definition"
    :available-elements="availableElements"
    :default-widgets="defaultWidgets"
    :options="options"
    :context="context"
    :set-context="setDefinition"
  />
</template>

<script>
// Components
import Widgets from './Widgets'

const mapSlugs = {
  'value-per-department-over-time': 'value-per-department',
  'share-per-department': 'share-per-department',
  'budget-vs-actual-per-department-version-1': 'budget-vs-actual-v1',
  'budget-vs-actual-per-department-version-2': 'budget-vs-actual-v2',
  'share-per-product-type': 'share-per-product-type',
  'share-per-subject-category': 'share-per-subject-category',
  'share-per-publisher': 'share-per-publisher',
  'share-per-vendor': 'share-per-vendor'
}

export default {
  components: {
    Widgets
  },

  props: {
    definition: {
      type: Array,
      required: true
    },
    initialDefinition: {
      type: Array,
      required: true
    },
    availableElements: {
      type: Array,
      required: true
    },
    context: {
      type: Object,
      required: true
    },
    setDefinition: {
      type: Function,
      required: true
    }
  },

  computed: {
    defaultWidgets() {
      const elements = this.getDefaultElements()
      return elements.map(el => ({
        id: el.id,
        type: mapSlugs[el.slug],
        colspan: 4,
        name: el.name
      }))
    },

    options() {
      return this.availableElements.map(el => ({
        uid: el.id,
        label: el.name,
        value: mapSlugs[el.slug],
        enabled: el.enabled
      }))
    }
  },

  created() {
    this.initDefinition(this.initialDefinition)
  },

  methods: {
    initDefinition(definition) {
      definition.length ? this.setDefinition(definition) : this.setDefinition(this.defaultWidgets)
    },

    getDefaultElements() {
      const { context, availableElements: elements } = this
      if (context.name === 'main') return elements.slice(0, 3) // first 3 widgets

      const charts = ['share-per-vendor', 'share-per-publisher', 'share-per-product-type']
      return elements.filter(el => charts.includes(el.slug))
    }
  }
}
</script>
